import generateFilterForQuery from './_tools';

export class DealProductsStatisticQuery {

  static PAGE_SIZE = 1000;

  static build(query: any) {
    return {
      columns: DealProductsStatisticQuery.COLUMNS,
      from: DealProductsStatisticQuery.buildFrom(query),
      from_as: DealProductsStatisticQuery.FROM_AS,
      // joins: DealProductsStatisticQuery.JOINS,
      groups: DealProductsStatisticQuery.GROUPS,
      page_size: DealProductsStatisticQuery.PAGE_SIZE,
      page: 1,
      ...({
          order: [
            { $asc: [ 'containers.product_name' ] }
          ]
      }),
    }
  }

  static COLUMNS: any = {
    is_utilization: 'containers.return_type_id',
    product_id: 'containers.product_id',
    product_type: 'containers.product_type',
    product_type_leaf: 'containers.product_type_leaf',
    product_type_root: 'containers.product_type_root',
    return: { $lt: [{$sum: 'containers.weight'}, {$: '0'}] },
    not_return: { $gt: [{$sum: 'containers.weight'}, {$: '0'}] },
    containers: {
      $array_agg: {
        $obj: {
          product_name: 'containers.product_name',
          product_type: 'containers.product_type',
          product_type_leaf: 'containers.product_type_leaf',
          product_type_root: 'containers.product_type_root',
          container_name: 'containers.name',
          container_count: 'containers.count',
          container_weight: 'containers.weight',
          return: { $lt: ['containers.weight', {$: '0'}] },
          not_return: { $gt: ['containers.weight', {$: '0'}] },
        }
      }
    },
    container_count_sum: {
      $sum: 'containers.count'
    },
    container_weight_sum: {
      $sum: 'containers.weight'
    }
  };

  static buildFrom(query: any) {
    const filter = generateFilterForQuery(query);

    return{
      columns: {
        product_id: 'p.id',
        product_name: 'p.name',
        // leaf = products.type_id (type or parent_product); root = type via coalesce(parent_id, id)
        product_type_leaf: 'pt.name',
        product_type_root: 'root_pt.name',
        product_type: 'root_pt.name',
        name: 'pc.name',
        return_type_id: {$eq: ['deal.return_type_id', {$: 'd:deals_return_types:1'}]},
        count: {
          $sum: 'dpc.container_quantity'
        },
        weight: {
          $sum: {
            $case: [
              [
                'pc.price_per_kg',
                'dpc.container_weight'
              ],
              [
                {
                  $: true
                },
                {
                  $mul: [
                    'pc.weight',
                    'dpc.container_quantity'
                  ]
                }
              ]
            ]
          }
        }
      },
      from: 's:deal_product_containers',
      from_as: 'dpc',
      joins: [
        {
          join: 's:deals',
          as: 'deal',
          on: {
            $eq: [
              'deal.id',
              'dpc.deal_id'
            ]
          }
        },
        {
          join: 's:product_containers',
          as: 'pc',
          on: {
            $eq: [
              'pc.id',
              'dpc.product_container_id'
            ]
          }
        },
        {
          join: 's:products',
          as: 'p',
          on: {
            $eq: [
              'p.id',
              'pc.product_id'
            ]
          }
        },
        {
          join: 's:products_types',
          as: 'pt',
          on: {
            $eq: [
              'p.type_id',
              'pt.id'
            ]
          }
        },
        {
          join: 's:products_types',
          as: 'root_pt',
          type: 'left',
          on: {
            $or: [
              {
                $and: [
                  { $null: ['pt.parent_id'] },
                  { $eq: ['root_pt.id', 'pt.id'] },
                ]
              },
              {
                $eq: ['root_pt.id', 'pt.parent_id']
              }
            ]
          }
        },
      ],
      order: [
        { $asc: [ 'root_pt.name' ] },
        { $asc: [ 'pt.name' ] },
        { $asc: [ 'pc.name' ] },
        { $asc: [ 'pc.weight' ] }
      ],
      where: {
        $in: [
          'dpc.deal_id',
          {
            columns: {
              id: 'deal.id'
            },
            from: 's:deals',
            from_as: 'deal',
            joins: [
              {
                join: 's:clients',
                as: 'client',
                on: {
                  $eq: [
                    'deal.client_id',
                    'client.id'
                  ]
                }
              },
              {
                join: 's:delivery_points',
                type: 'left',
                as: 'point',
                on: {
                  $eq: [
                    'deal.delivery_point_id',
                    'point.id'
                  ]
                }
              },
              {
                join: 's:cities',
                type: 'left',
                as: 'city',
                on: {
                  $eq: [
                    'point.city_id',
                    'city.id'
                  ]
                }
              },
              {
                join: 's:statuses',
                type: 'left',
                as: 'status',
                on: {
                  $eq: [
                    'deal.status_id',
                    'status.id'
                  ]
                }
              },
              {
                join: 's:delivery_points',
                type: 'left',
                as:   'delivery_points',
                on: {
                  $eq: ['delivery_points.id', 'deal.delivery_point_id']
                }
              },
              {
                join: {
                  columns: {
                    deal_id: 'dpc.deal_id',
                    sapmle_count: { $count: 'dpc.id' }
                  },
                  from: 's:deal_product_containers',
                  from_as: 'dpc',
                  joins: [
                    {
                      join: 's:product_containers',
                      type: 'left',
                      as:   'pc',
                      on: {
                        $eq: ['pc.id', 'dpc.product_container_id']
                      }
                    },
                  ],
                  groups: [
                    'dpc.deal_id'
                  ],
                  where: {
                    $or: [
                      { $eq: ['dpc.is_sample', { $: true } ] },
                      { $eq: ['pc.is_sample', { $: true } ] },
                    ]
                  }
                },
                type: 'left',
                as: 'dpc_with_samples',
                on: { $eq: ['dpc_with_samples.deal_id', 'deal.id'] }
              }
            ],
            where: {
              $and: [
                {
                  $or: [
                    { $null: [ 'status.final' ] },
                    { $eq: [ 'status.final', { $: 'success'}]}
                  ]
                },
                ...filter
              ],
            }
          }
        ]
      },
      groups: [
        'root_pt.name',
        'pt.name',
        'p.id',
        'p.name',
        'pc.id',
        'pc.name',
        'deal.return_type_id'
      ]
    };
  }

  static FROM_AS: string = 'containers';

  static GROUPS: any[] = [
    'containers.product_id',
    'containers.product_name',
    'containers.return_type_id',
    'containers.product_type',
    'containers.product_type_leaf',
    'containers.product_type_root',
  ]
}
